import React from 'react';
import {
  ATMButton,
  ATMDropdown,
  ATMPopover,
  ORGDataTable,
  IORGDataTableColumn,
  IORGDataTableQueryState,
} from 'shared-it-appmod-ui';
import Lang from 'src/libraries/language';
import Moment from 'src/libraries/moment.library';
import { IChangeLog } from 'src/models/change-log.model';
import style from './change-logs.module.scss';

type IProp = {
  data: IChangeLog[];
  total: number;
  loading: boolean;
  handleFetch: (params: IORGDataTableQueryState) => void;
};

const ChangeLogs: React.FC<IProp> = ({ data, total, loading, handleFetch }) => {
  const fieldOptions = Array.from(
    new Set(data.map((log) => log.ChangeLogDetail?.field ?? null))
  )
    .filter(Boolean)
    .map((log) => ({
      key: log ?? '',
      value: log ?? '',
      text: log?.replace('_', ' ') ?? '',
    }));

  const compressString = (field: string, value: string | undefined) => {
    return value && value.length > 80 ? (
      <span>
        {`${value.substr(0, 80)}...`}
        <ATMPopover
          trigger={
            <a className={style.borderless}>
              <ATMButton
                basic
                color="blue"
                content={Lang.LBL_READ_MORE}
                style={{
                  textDecoration: 'underline',
                  fontWeight: 'bolder',
                  padding: 'unset',
                }}
              />
            </a>
          }
          hoverable
          mouseLeaveDelay={250}
          position="left center"
        >
          {field.includes('Date')
            ? Moment.utc(value).format('MM/DD/YYYY HH:mm A')
            : value}
        </ATMPopover>
      </span>
    ) : (
      <span>
        {field.includes('Date')
          ? Moment.utc(value).format('MM/DD/YYYY HH:mm A')
          : value}
      </span>
    );
  };
  const customColumns: IORGDataTableColumn<IChangeLog>[] = [
    {
      title: Lang.LBL_CHANGELOG_DATE_TIME,
      index: 'lastModifiedDate',
      render: (_, value) => (
        <>
          {Moment.tz(value.lastModifiedDate, 'America/Los_Angeles').format(
            'MM/DD/YYYY - HHmm'
          )}{' '}
          hrs
        </>
      ),
      width: '20%',
    },
    {
      title: Lang.LBL_CHANGELOG_BY,
      index: 'modifiedByName',
      width: '20%',
    },
    {
      title: Lang.LBL_CHANGELOG_FIELD,
      index: 'ChangeLogDetail.field',
      render: (_, value) => value.ChangeLogDetail?.field.replace('_', ' '),
      width: '20%',
    },
    {
      title: Lang.LBL_CHANGELOG_NEW_VALUE,
      index: 'ChangeLogDetail.newValue',
      render: (_, value) =>
        compressString(
          value.ChangeLogDetail?.field ?? '',
          value.ChangeLogDetail?.newValue ?? ''
        ),
      width: '20%',
    },
    {
      title: Lang.LBL_CHANGELOG_OLD_VALUE,
      index: 'ChangeLogDetail.oldValue',
      render: (_, value) =>
        compressString(
          value.ChangeLogDetail?.field ?? '',
          value.ChangeLogDetail?.oldValue ?? ''
        ),
      width: '20%',
    },
  ];
  return (
    <>
      <ORGDataTable
        celled={false}
        columns={customColumns}
        data={data}
        onChange={handleFetch}
        total={total}
        loading={loading}
        addParams={['field']}
        rowsPerPageOptions={[10, 25, 50, 100]}
        counter
      >
        {({ state, setState }) => ({
          toolbars: [
            () => (
              <ATMDropdown
                selection
                defaultValue="All Fields"
                options={[
                  {
                    key: 'All_Fields',
                    value: 'All Fields',
                    text: 'All Fields',
                  },
                  ...fieldOptions,
                ]}
                onChange={(_, val) => {
                  if (val.value !== 'All Fields') {
                    setState({
                      ...state,
                      page: 1,
                      field: val.value,
                    });
                  } else {
                    setState({
                      ...state,
                      page: 1,
                      field: undefined,
                    });
                  }
                }}
              />
            ),
          ],
        })}
      </ORGDataTable>
    </>
  );
};

export default ChangeLogs;
